
export default {
  name: 'BbList',
  props: {
    value: {
      default: '',
    },
  },
  computed: {
    selectedItem: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
